<template>
  <div class="home-header">
    <img class="logo" :src="logo" @click="toHome" />
    <div class="header-right">
      <div class="icon-wrapper">
        <i
          class="iconfont icon-guanbi1"
          v-if="headerMenuShow"
          @click.stop="toggleHeaderMenu"
        ></i>
        <i
          class="iconfont icon-caidan"
          v-else
          @click.stop="toggleHeaderMenu"
        ></i>
      </div>
      <van-dropdown-menu class="header-menu">
        <van-dropdown-item
          ref="headerMenu"
          @open="haderMenuChange"
          @close="haderMenuChange"
        >
          <ul class="operation-list" v-if="!user.userId">
            <li @click="toHome">{{ $t("pages_Page_homeHeader_4") }}</li>
            <li @click="toLogin">{{ $t("pages_Page_homeHeader_5") }}</li>
          </ul>
          <ul class="operation-list" v-else>
            <li @click="toHome">{{ $t("pages_Page_homeHeader_6") }}</li>
            <li @click="switchRole" v-if="user.role == 8 || isSwitch == 1">
              {{
                isSwitch == 1 ? $t("virtual.toggleTeacherMode") : $t("virtual.toggleStudentMode")
              }}
            </li>
            <li @click="logout">{{ $t("pages_Page_homeHeader_8") }}</li>
          </ul>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { UMOOC_SERVER_HOST, UMOOC_WEB_HOST, hostDomain } from "@/config";
import cookies from "@/utils/cookie";
export default {
  name: "component-home-header",
  data() {
    return {
      headerMenuShow: false,
      isSwitch: "",
    };
  },
  created() {
    this.isSwitch = cookies.get("isSwitch");
  },
  computed: {
    ...mapGetters({ user: "user/user", org: "org/org" }),
    logo() {
      //调用接口获取机构logo
      if (!this.org.isMainSite) {
        return this.org.logo;
      }
      return require("@/assets/images/logo.png");
    },
  },
  methods: {
    toHome() {
      let url = `${UMOOC_SERVER_HOST}`;
      if (!this.org.isMainSite) {
        url = `https://${this.org.prefix + hostDomain}`;
      }
      location.href = url;
    },
    toLogin() {
      cookies.set("loginRedirectUrl", location.href);
      let url = `${UMOOC_WEB_HOST}/pc.html#/login`;
      if (!this.org.isMainSite) {
        url = `https://${this.org.prefix + hostDomain}/sld/pc.html#/login`;
      }
      location.href = url;
    },
    toggleHeaderMenu() {
      this.$refs.headerMenu.toggle();
    },
    haderMenuChange() {
      this.headerMenuShow = this.$refs.headerMenu.showPopup;
    },
    switchRole() {
      this.user.switchRole();
    },
    logout() {
      this.user.logout();
    },
  },
};
</script>

<style lang="scss" scoped>
.home-header {
  display: flex;
  height: 46px;
  padding: 0 10px;
  align-items: center;
  justify-content: space-between;
  .logo {
    height: 24px;
  }
  i {
    font-size: 20px;
  }
}
.header-right {
  position: relative;
  width: 40px;
  line-height: 46px;
  text-align: center;
}
.icon-wrapper {
  position: absolute;
  z-index: 1111;
  background-color: #fff;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
}
.header-menu {
  // width: 0;
  // height: 0;
  ::v-deep {
    .van-dropdown-menu__bar {
      height: 45px;
    }
  }
  .operation-list {
    border-top: $--border-base;
    line-height: 52px;
    font-size: 15px;
  }
}
</style>